import React, {useState, useEffect} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ChangeUsername from "../Profile/changeUser";
import {Bar} from 'react-chartjs-2';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button'
import FetchUserBreakdown from "../Graphs/fetchUserBreakdown";
import GoldenTicket from "../Forms/GoldenTicket"



const Profile = () => {
  const { user, isAuthenticated } = useAuth0();
  const [userProfile, setUserProfile] = useState([]);
  const [isLoaded,setIsLoaded] = useState(false);

  console.log(user)

  const loadUserProfile = async (userID,userEmail,userNick) => {
    console.log(user)
    const data = await fetch("https://settersbloc.com/api/fetch_profile.php",{
      method: 'POST',
      body: JSON.stringify({
        user_id: userID,
        user_email: userEmail,
        user_nick: userNick   
      })
    })
    .then(result => result.json())
    .then((result) => {
        console.log(result)
        setUserProfile(result)
        setIsLoaded(true)
      }
    );
  }

  useEffect(()=>{
    if(isAuthenticated){
      loadUserProfile(user.sub,user.email,user.nickname)
    }
  },[isAuthenticated])

  console.log(userProfile)
  if(isAuthenticated && isLoaded ){
    return (
      <div>
        
        <ChangeUsername user={userProfile} />

        
      </div>
    )
  } else {
    return(
      <div>
      Loading ...
    </div>
    )
  }
};

export default Profile;